var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BreadBrowseTable',{attrs:{"role":"Moderator","model":_vm.model,"url":((this.$api.servers.game) + "/api/v1/zh/moderator/gallery/countByPlayer"),"isSearchable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }